import { render } from "./ColisPostauxPage.vue?vue&type=template&id=5f17b3a1"
import script from "./ColisPostauxPage.vue?vue&type=script&lang=js"
export * from "./ColisPostauxPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__